import React, { Component } from 'react';
import {connect} from 'react-redux';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import {resetPassword, initPwdForm} from '../../../actions';
import formStyles from '../FormPanel.scss'
import Loading from '../../Loading/Loading';

const ResetSchema = Yup.object().shape({
  emailAddress: Yup.string()
    .email('Please use a valid email address')
    .required('Please provide an email address'),
});

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.emailAddress = '';
  }
  componentWillUnmount() {
    this.props.initPwdForm(); // reset the form state since we're using state to display
  }
  render() {
    return (
      <div className={formStyles.formBody}>
        <div className={formStyles.formPanel}>
          {(this.props.passwordReset == 'success') ? 
            <p>Your Password Reset request was received. If you have a registered account with us, you will receive the instructions at your nominated email address.</p>
          : 
            <div>
              {(this.props.passwordReset == 'fetching') ? <Loading /> : null}

              <p className="text-center">There, there. We'll get you back up and running in no time!<br/>
              Enter the email address you use to login.</p>
              <p className="text-center">We'll send you a message with instructions on how to reset your password.</p>
              <Formik
                initialValues={{
                  emailAddress: '',
                }}
                validationSchema={ResetSchema}
                onSubmit={(values) => {
                  this.emailAddress = values.emailAddress;
                  this.props.resetPassword(values);
                }}
              >
              {({ props, errors, touched }) => (
                <Form>
                  <div className={formStyles.fieldRow}>
                    <div>
                      <div><label htmlFor="resetEmail" className="smText">Email address</label></div>
                      <div><Field id="resetEmail" name="emailAddress" className={((errors.emailAddress && touched.emailAddress) ? formStyles.othFormInputErr + ' ' : '') + formStyles.othFormInput} /></div>
                      <div className={formStyles.validationMessage + ' smText '
                        + ((errors.emailAddress && touched.emailAddress)? formStyles.validationMessageShown : '')}
                      >
                        <ErrorMessage name="emailAddress"></ErrorMessage>
                      </div>
                    </div>
                  </div>
                  <div className={formStyles.fieldRow + ' text-center'}>
                    <button className="odinButton col-6" type="submit">Continue</button>
                  </div>
                </Form>)}
              </Formik>
            </div>
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({ passwordReset: state.resetPasswordRdc.status});
const mapDispatchToProps = {resetPassword, initPwdForm};
export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);

